module.exports = __webpack_public_path__ + "img/icon_backspace.ad1460c5.svg";